/* Decorative only: the existing cart links, counts and drawer keep their behavior. */
(() => {
  const markup = "<svg class=\"jmt-fall-cauldron\" viewBox=\"0 0 44 46\" fill=\"none\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M8 23 12 40h22l4-17z\" fill=\"#37261b\" stroke=\"#d9ac62\" stroke-width=\"2\"/><path d=\"M14 22q1-19 10-19t10 19M9 27h28m-23 5h20m-17 5h14\" stroke=\"#d9ac62\" stroke-width=\"2\" fill=\"none\"/><g class=\"season-item season-item-1\" transform=\"translate(12 15)\"><path fill=\"#d9ac62\" d=\"M0 10Q-8 0 6-5q6 13-6 15\"/></g><g class=\"season-item season-item-2\" transform=\"translate(31 10)\"><path fill=\"#d9ac62\" d=\"M0 10Q-8 0 6-5q6 13-6 15\"/></g><g class=\"season-item season-item-3\" transform=\"translate(21 4)\"><path fill=\"#d9ac62\" d=\"M0 10Q-8 0 6-5q6 13-6 15\"/></g></svg>";
  function mount(root, countSelector) {
    if (!root) return;
    function sync() {
      const count = Math.max(0, parseInt(root.querySelector(countSelector)?.textContent || '0', 10) || 0);
      const level = String(Math.min(count, 3));
      let icon = root.querySelector('.jmt-fall-cauldron');
      if (!icon) {
        const original = root.querySelector('.svg-wrapper') || root.querySelector('svg');
        if (!original) return;
        const holder = document.createElement('span');
        holder.innerHTML = markup;
        original.replaceWith(holder.firstElementChild);
        icon = root.querySelector('.jmt-fall-cauldron');
      }
      if (icon.dataset.level !== level) icon.dataset.level = level;
    }
    sync();
    // Observe just the two existing cart controls, with no polling or cart requests.
    new MutationObserver(sync).observe(root, { childList:true, subtree:true, characterData:true });
  }
  mount(document.getElementById('cart-icon-bubble'), '.cart-count-bubble span[aria-hidden="true"]');
  mount(document.getElementById('jmt-prefbar-cart'), '#jmt-prefbar-cart-count');
})();
